import React from 'react';

import { DomainConfigurationDto } from '@/types/DomainConfigurationDto';

type TabListLineProps = {
    domainConfiguration?: DomainConfigurationDto;
};

function TabListLine(props: TabListLineProps): React.JSX.Element {
    const { domainConfiguration } = props;
    return (
        <div className="absolute left-0 bottom-0 w-full">
            <div
                className="-mt-2 border-b-2"
                style={{
                    ...(domainConfiguration
                        ? {
                              borderColor: domainConfiguration.style.onBackgroundColor
                          }
                        : undefined),
                    opacity: 0.2
                }}
            />
        </div>
    );
}

export default TabListLine;
